import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";
import { definirTitularDoPdf, linhaDoTitular } from "@/lib/titular-pdf";

/**
 * Sem interface: lê o titular da conta UMA vez e o entrega aos geradores de PDF
 * (`src/lib/titular-pdf.ts`). Pessoa física não carrega nem decifra nada — só empresa passa
 * pelo `decrypt_cpf`. Falha na leitura deixa o PDF sem a linha, nunca com uma errada.
 */
export function TitularPdfSync() {
  const { user } = useAuth();

  const { data: linha } = useQuery({
    queryKey: ["titular-pdf", user?.id],
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<string | null> => {
      const { data: row, error } = await (supabase as any)
        .from("profiles")
        .select("tipo_pessoa, razao_social, documento")
        .eq("user_id", user!.id)
        .single();
      if (error) throw error;
      if (row.tipo_pessoa !== "juridica") return null;

      let claro: string | null = row.documento ?? null;
      if (claro) {
        const { data: dec, error: decError } = await supabase.rpc("decrypt_cpf", { cipher: claro });
        if (decError) throw decError;
        claro = dec as string;
      }
      return linhaDoTitular({ tipo_pessoa: row.tipo_pessoa, razao_social: row.razao_social, documento: claro });
    },
  });

  useEffect(() => {
    definirTitularDoPdf(linha ?? null);
    return () => definirTitularDoPdf(null);
  }, [linha]);

  return null;
}
